export default __webpack_public_path__ + "static/media/wbtc-logo.40dd0704.png";